import Ajax from '../../ajax';

export default class NextVideoService {
  static request(videoId, callback){
    Ajax.get({
      url: `/videos/${videoId}/next_video`,
      success: (response) => {
        window.NextVideoData = JSON.parse(response);

        callback(window.NextVideoData !== null);
      },
      error: null
    });
  }

  static dataIsExists(){
    return window.NextVideoData !== undefined && window.NextVideoData !== null;
  }

  static data(){
    return window.NextVideoData;
  }

  static watchpageUrl(){
    if(!this.dataIsExists()) return null;

    if(this.data().watchpage_url !== undefined)
      return this.data().watchpage_url;
    else
      return `/watch/${this.data().id}`
  }
}
